module.exports = __webpack_public_path__ + "static/media/add.aba9de2d.png";